import React, { useEffect } from 'react'

const ThreeStateCheckbox = ({ checked, onChange, isDisabled = false }) => {
    const updateInput = (ref, checked) => {
        const input = ref.current;
        if (input) {
            input.checked = checked;
            input.indeterminate = checked == null;
            checked === null ? input.classList.add('unknown') : input.classList.remove('unknown')
        }
    };
    const inputRef = React.useRef(null);
    const checkedRef = React.useRef(checked);

    useEffect(() => {
        checkedRef.current = checked;
        updateInput(inputRef, checked);
    }, [checked]);

    const handleClick = () => {
        switch (checkedRef.current) {
            case true || 1:
                checkedRef.current = false;
                inputRef.current.classList.add('no')
                inputRef.current.classList.remove('unknown', 'yes')
                break;
            case 0:
            case false:
                checkedRef.current = null;
                inputRef.current.classList.add('unknown')
                inputRef.current.classList.remove('no', 'yes')
                break;
            default: // null
                checkedRef.current = true;
                inputRef.current.classList.add('yes')
                inputRef.current.classList.remove('unknown', 'no')
                break;
        }

        updateInput(inputRef, checkedRef.current);

        if (onChange) {
            onChange(checkedRef.current);
        }
    };
    return (
        <label className="tri-state-checkbox-container flex justify-center align-center">
            <input className="tri-state-checkbox" ref={inputRef} type="checkbox" onClick={handleClick} disabled={isDisabled}/>
        </label>
    );
};

export default ThreeStateCheckbox;
